import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-sent-notification',
  templateUrl: './email-sent-notification.component.html',
  styleUrls: ['./email-sent-notification.component.scss']
})
export class EmailSentNotificationComponent {
  constructor(private dialogRef: MatDialogRef<EmailSentNotificationComponent>) { }

  closeDialog() {
    this.dialogRef.close(true);
  }
}
